/*
     Title: Constant for TIME
     Description: Constant for TIME
     Author: Iqbal Hossain
     Date: 06-January-2022
     Modified: 11-January-2022
*/

export const FETCH_TIME = 'FETCH_TIME';
export const TOGGLE_TIME_SIDEBAR = 'TOGGLE_TIME_SIDEBAR';
export const TOGGLE_TIME_STATUS = 'TOGGLE_TIME_STATUS';
export const FETCH_TIME_BY_QUERY = 'FETCH_TIME_BY_QUERY';
export const ADD_TIME = 'ADD_TIME';
export const DELETE_TIME = 'DELETE_TIME';
export const FETCH_TIME_BY_ID = 'FETCH_TIME_BY_ID';
export const UPDATE_TIME = 'UPDATE_TIME';
export const DELETE_TIME_BY_RANGE = 'DELETE_TIME_BY_RANGE';

/** Change Log
 * 11-Jan-2022(Iqbal): Add TOGGLE_TIME_SIDEBAR, FETCH_TIME_BY_QUERY, ADD_TIME, DELETE_TIME, FETCH_TIME_BY_ID, UPDATE_TIME, DELETE_TIME_BY_RANGE
 */
